import * as ko from "knockout";
import { CustomObservables } from "CustomObservables";
import entityBase from "entityBase";

export class step extends entityBase {
  sequence: KnockoutObservable<string>;
  required: KnockoutObservable<boolean>;
  required_t: KnockoutObservable<string>;
  step_name: KnockoutObservable<string>;
  step_type: KnockoutObservable<string>;
  text: KnockoutObservable<string>;
  completed: KnockoutObservable<boolean>;
  completed_t: KnockoutObservable<string>;
  completed_on: KnockoutObservable<any>;
  completed_as_of: KnockoutObservable<any>;
  step_id: KnockoutObservable<any>;
  task_id: KnockoutObservable<any>;
  task_step_id: KnockoutObservable<any>;

  constructor(item: any) {
    super();

    this.sequence = ko.observable(item.sequence ? item.sequence : "");
    this.required_t = ko.observable(item.required);
    this.step_id = ko.observable(item.step_id ? item.step_id : "");
    this.task_id = ko.observable(item.task_id ? item.task_id : "");
    this.task_step_id = ko.observable(item.task_step_id ? item.task_step_id : "");
    this.completed_as_of = ko.observable(item.completed_as_of);
    this.completed_on = ko.observable(item.completed_on);
    this.required = ko.pureComputed({
      read: () => {
        return this.required_t && this.required_t() == "Y";
      },
      write: (value: boolean) => {
        this.required_t(value ? "Y" : "");
      },
    });

    this.completed_t = ko.observable(item.completed);
    this.completed = ko.pureComputed({
      read: () => {
        return this.completed_t && this.completed_t() == "Y";
      },
      write: (value: boolean) => {
        this.completed_t(value ? "Y" : "");
      },
    });

    this.step_name = ko.observable(item.step_name ? item.step_name : "");
    this.text = ko.observable(item.text ? item.text : "");
    this.step_type = ko.observable(item.step_type ? item.step_type : "");

    if (item.completed_as_of && item.completed_as_of !== "") {
      var completed_date = ko.observable(this.formatJSONDate(item.completed_as_of));
      this.completed_on = CustomObservables.formattedDateTimeObservable(completed_date);
    }
  }
}
